import React from "react";

export const FilterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M3 7.5H21"
        stroke="#71717A"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M6 12.5H18"
        stroke="#71717A"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M10 17.5H14"
        stroke="#71717A"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
};
